import { useMemo } from 'react'
import { BaseTaskForm, TaskParams } from '../../BaseTaskForm'

interface MuleSoftToNodeJsFormProps {
  onChange: (task: TaskParams) => void
  withExamplePrefilled?: boolean
  initialTaskData?: TaskParams | null
}

export function MuleSoftToNodeJsForm({
  onChange,
  withExamplePrefilled,
  initialTaskData
}: MuleSoftToNodeJsFormProps) {
  // Initialize from initialTaskData if editing, otherwise use example or empty
  // Use useMemo to recompute when withExamplePrefilled changes
  const initialDescription = useMemo(() => {
    if (initialTaskData?.request?.command?.commandString) {
      return initialTaskData.request.command.commandString
    }
    return withExamplePrefilled ? `curie_v2:migrate process-orders-flow to node js` : ''
  }, [initialTaskData?.request?.command?.commandString, withExamplePrefilled])

  return (
    <BaseTaskForm
      enter2Submit
      label='Describe the task'
      onChange={onChange}
      placeholder='curie_v2:migrate <flow_name> to node js and use lamda $<lambda_name>'
      defaultValue={initialDescription}
      disabled={withExamplePrefilled}
    />
  )
}
